"use client";
import dynamic from "next/dynamic";
import { ImageAttr } from "./attributes";
import { useAttr, useBlock } from "./context";
import type { ImageValue } from "../media-shared";
import type { ImageAttrProps } from "./attributes.types";
import { imagePresentation } from "./image-presentation";

const ImageOptions = dynamic(() => import("./ImageOptions"), { ssr: false });

export type AdvancedImageAttrProps = ImageAttrProps & {
  /** A fixed theme choice hides the corresponding editor option. */
  fit?: "cover" | "contain";
  position?: string;
  defaultFit?: "cover" | "contain";
  defaultPosition?: string;
};

/** Drop-in image attribute; old snapshots and ImageAttr remain supported. */
export function AdvancedImageAttr(props: AdvancedImageAttrProps) {
  const { fit, position, defaultFit, defaultPosition, imageStyle, ...imageProps } = props;
  const ctx = useBlock();
  const [value] = useAttr<ImageValue | null>(props.name);
  const presentation = imagePresentation(value, { fit, position, defaultFit, defaultPosition });
  return <>
    <ImageAttr {...imageProps} imageStyle={{ ...imageStyle, objectFit: presentation.fit, objectPosition: presentation.position }} />
    {ctx.editing && value?.src && (!fit || !position) && <ImageOptions name={props.name} fit={presentation.fit} position={presentation.position} fixedFit={!!fit} fixedPosition={!!position} />}
  </>;
}
